import { Component, inject } from '@angular/core';
import { ApplicationCommonComponent } from '../../../common/application.common.component';
import { stages } from '../../municipal-waste-disposal.routes';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MunicipalWasteDisposalDeclarationSubjectForm
} from './forms/municipal-waste-disposal-declaration-subject.form';
import { RouterLink } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';

@Component({
  selector: 'app-municipal-waste-disposal-declaration-subject-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    RouterLink,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  providers: [
    MunicipalWasteDisposalDeclarationSubjectForm
  ],
  templateUrl: './municipal-waste-disposal-declaration-subject-section.component.html'
})
export class MunicipalWasteDisposalDeclarationSubjectSectionComponent extends ApplicationCommonComponent {

  public successUrl: string = this.route.snapshot.data['successUrl'];

  public stages: string[] = stages;

  public form: MunicipalWasteDisposalDeclarationSubjectForm = inject(MunicipalWasteDisposalDeclarationSubjectForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.updateApplication(this.successUrl.replaceAll('../', ''), this.form.toWriteModel());
    } else {
      this.form.markAllAsTouched();
    }
  }
}
